import { FC, useState } from "react";
import TalkWithUs from "@/common/TalkWithUs";
import { FilterResponseTO, SearchResponseTO } from "../../models/search";
import Brochures from "../home/brochures/Brochures";
import HelpButtons from "./HelpButtons";
import ToursDestinationsHead from "./ToursDestinationsHead";
import ToursDestinationsSearch from "./ToursDestinationsSearch";
import { useIsMD } from "../../utils/hooks/useWindowSizes";

const ToursDestinationsBody: FC<{
    filtersData: FilterResponseTO;
    packageData: SearchResponseTO[];
    initialSelectedDestination: string[];
    initialSelectedTourType: string[];
    initialSelectedTagDestination: string | null;
}> = ({
    filtersData,
    packageData,
    initialSelectedDestination,
    initialSelectedTourType,
    initialSelectedTagDestination,
}) => {
    const [showModal, setShowModal] = useState(false);

    const [numberFilteredPackage, setNumberFilteredPackage] = useState<number>(
        packageData.length
    );

    /*
        E' richiesta di playitaly visualizzare i tour in pagine senza nessun filtro iniziale.
        A db viene creata sempre sia un entità in tourQuality che in tourPremium
        Se il tour è solo premium il servizio ritornerà un attributo con nome onlyPremium
        Se il tour è solo quality il servizio ritornerà un attributo con nome onlyQuality
        Se il tour è sia quality che premium non avremo ne onlyPremium ne onlyQuality
    */

    return (
        <div className="minWidth100vwFromXL">
            {!useIsMD() && <HelpButtons setShowModal={setShowModal} />}
            <ToursDestinationsHead
                numberFilteredPackage={numberFilteredPackage}
            />
            <ToursDestinationsSearch
                initialSelectedDestination={initialSelectedDestination}
                initialSelectedTourType={initialSelectedTourType}
                initialSelectedTagDestination={initialSelectedTagDestination}
                filtersData={filtersData}
                packageData={packageData}
                setNumberFilteredPackage={setNumberFilteredPackage}
            />
            <Brochures />
            <TalkWithUs show={showModal} setShow={setShowModal} />
        </div>
    );
};

export default ToursDestinationsBody;
